import { Element, Transforms, Range, Editor, Node } from 'slate';
import { CustomEditor, HighlightElement } from 'slate/types/slate';

export const isHighlight = (element: Node): element is HighlightElement => Element.isElement(element) && element.type === 'highlight';

export const insertHighLight = async (editor: CustomEditor, commentId: string) => {
  if (!editor.selection || Range.isCollapsed(editor.selection)) return;
  const highlight: HighlightElement = {
    type: 'highlight',
    children: [],
    highlighted: true,
    id: commentId,
  };

  Transforms.wrapNodes(editor, highlight, { split: true });
};

export const getAllHighlights = (editor: CustomEditor) => {
  const highLights = Array.from(
    Editor.nodes(editor, {
      at: [],
      match: (n) => Element.isElement(n) && n.type === 'highlight',
    })
  );

  return highLights.map(([node, path]) => ({
    node,
    path,
  }));
};

export const toggleHighlight = (editor: CustomEditor, commentId: string) => {
  const highlights = getAllHighlights(editor);
  highlights.forEach(({ node, path }) => {
    if (isHighlight(node) && node.id === commentId) {
      Transforms.setNodes(editor, { highlighted: true }, { at: path });
    } else {
      Transforms.setNodes(editor, { highlighted: false }, { at: path });
    }
  });
};
